import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import { styles } from './styles';

const PageLoader = ({ children, isLoading = false }) => {
	if (isLoading) {
		return (
			<Box sx={styles.centered}>
				<CircularProgress size={100} sx={styles.fabProgress} />
			</Box>
		);
	}

	return children;
};

export default PageLoader;
